import React, { useEffect, useState } from "react";
import "./animations.css";
import hero_bg from "../Assets/hero_bg.png";
import naija_electric from "../Assets/naija_electric.png";
import { HiArrowRight } from "react-icons/hi";
import { HiOutlineChevronDown } from "react-icons/hi2";

const Secone = () => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    setShowContent(true);
  }, []);

  return (
    <div
      className="relative h-screen w-full overflow-hidden text-white bg-black"
      style={{
        backgroundImage: `url(${hero_bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Gradient overlay for readability + depth */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />

      <div className="relative z-10 h-full flex flex-col justify-center px-6 md:px-10 lg:px-16 w-full md:w-[34rem]">
        {/* Eyebrow badge */}
        <span
          className={`inline-flex items-center gap-2 w-fit px-3 py-1 rounded-full text-xs font-semibold tracking-wide uppercase bg-[#6ab615]/20 text-[#8fe33a] border border-[#6ab615]/40 mb-6 ${
            showContent ? "p-slide-in" : "hidden-initially"
          }`}
        >
          <span className="size-1.5 rounded-full bg-[#8fe33a] animate-pulse" />
          Nigeria's Electric Future
        </span>

        <img
          src={naija_electric}
          alt="Naija Electric"
          className={`w-72 md:w-80 ${
            showContent ? "h2-slide-in" : "hidden-initially"
          }`}
        />

        <p
          className={`mt-6 text-xl md:text-2xl font-bold text-white/90 ${
            showContent ? "p-slide-in" : "hidden-initially"
          }`}
        >
          Buy an Electric Car Here
        </p>

        <p
          className={`mt-3 text-sm md:text-base text-white/60 max-w-md leading-relaxed ${
            showContent ? "p-slide-in" : "hidden-initially"
          }`}
        >
          Clean, affordable, and reliable electric vehicles built for
          Nigerian roads.
        </p>

        <button
          className={`group flex items-center gap-2 bg-[#6ab615] hover:bg-[#5a9b12] text-white font-semibold px-6 py-4 rounded-md mt-10 w-fit transition-all duration-200 shadow-lg shadow-[#6ab615]/20 hover:shadow-[#6ab615]/40 hover:-translate-y-0.5 ${
            showContent ? "p-slide-in" : "hidden-initially"
          }`}
        >
          GET A QUOTE
          <HiArrowRight className="transition-transform duration-200 group-hover:translate-x-1" />
        </button>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-1 text-white/50 animate-bounce">
        <span className="text-[10px] tracking-widest uppercase">Scroll</span>
        <HiOutlineChevronDown className="text-lg" />
      </div>
    </div>
  );
};

export default Secone;